<template>
  <d-card-header class="border-bottom flex-header komponent">
    <h6 class="m-0">
      <template v-if="!isDraft">
        Dane podstawowe umowy nr <span class="text-primary">{{ schedule.contract_number }}</span>
      </template>
      <template v-else>
        Dane podstawowe szkicu umowy
      </template>
      <br/>
      <span class="text-danger" v-if="!schedule.is_terminated && schedule.contract_end_date_has_passed">
        Umowa zakończona dnia: {{ schedule.contract_end_date }}
      </span>
      <br/>
      <span v-if="schedule.terminated_send_date && !schedule.terminated_date" class="text-danger">
        ({{ terminationSentText }} {{ schedule.terminated_send_date.substring(0, 10) }})
      </span>
    </h6>
    <template v-if="!isInSchedule">
      <div
        v-if="schedule.case_is_explained_date === null && !scheduleFinished && !isDraft"
        class="button-date-wrapper">
        <d-button
          style="width: 100%; margin-top: -1px;"
          class="ml-0"
          theme="danger">
          <span style="white-space: nowrap;">Umowa&nbsp;w&nbsp;egzekucji</span>
        </d-button>
        <ss-date
          @picked="scheduleInExecution"
          type="text"
          name="caseIsExplainedDate"
          v-model="caseIsExplainedDate"
          placeholder=""/>
      </div>
      <div
        v-if="!isForInternalClient && schedule.is_terminated !== 1 && !scheduleFinished && !isDraft && !schedule.terminated_send_date"
        class="button-date-wrapper ml-2">
        <d-button
          style="width: 100%; margin-top: -1px;"
          class="ml-0"
          theme="danger">
          <span style="white-space: nowrap;">{{ terminationNoticeButtonText }}</span>
        </d-button>
        <ss-date
          @picked="sendTerminationNotice"
          type="text"
          name="terminationSendDate"
          v-model="terminationSendDate"
          placeholder=""/>
      </div>
      <div
        v-if="!isForInternalClient && schedule.is_terminated !== 1 && !scheduleFinished && !isDraft && schedule.terminated_send_date"
        class="button-date-wrapper ml-2">
        <d-button
          style="width: 100%; margin-top: -1px;"
          class="ml-0"
          theme="danger">
          <span style="white-space: nowrap;">{{ terminateButtonText }}</span>
        </d-button>
        <ss-date
          @picked="terminateSchedule"
          type="text"
          name="terminatedDate"
          v-model="terminatedDate"
          placeholder=""/>
      </div>
    </template>

    <d-button
      v-if="schedule.is_archive === 0 && !isDraft"
      :class="{ isLoading: actionInProgress }"
      class="ml-2"
      @click.prevent="sendReminder">
      Wyślij podsumowanie
    </d-button>

    <template v-if="!isInSchedule">
      <d-button
        v-if="canArchiveContract && !isDraft && isAdmin === 1"
        @click.prevent="archiveContract">
        Archiwizuj umowę
      </d-button>
      <d-button
        v-else-if="scheduleFinished && schedule.is_archive == 2 && isAdmin === 1"
        @click.prevent="archiveContract">
        Potwierdź archiwizację umowy
      </d-button>
      <h6
        v-else-if="scheduleFinished && schedule.is_archive === 2  && isAdmin === 0 && !isDraft"
        class="text-right text-info d-inline-block">
        Oczekuje potwierdzenia archiwizacji
      </h6>
      <h6
        v-else-if="scheduleFinished && schedule.is_archive === 1 && !isDraft"
        class="text-right text-info d-inline-block">
        Umowa jest zarchiwizowana
      </h6>
    </template>
  </d-card-header>
</template>

<script>
import SsDate from '@/components/common/SsDate';

export default {
  name: 'ContractBasicInfoHeader',
  components: {
    SsDate,
  },
  props: {
    allGuaranteesHaveAgreement: {
      default: false,
      type: Boolean
    },
    isAdmin: {
      default: 0,
      type: Number
    },
    isDraft: {
      required: true,
      type: Boolean
    },
    isForInternalClient: {
      default: false,
      type: Boolean
    },
    isInSchedule: {
      default: false,
      type: Boolean
    },
    schedule: {
      required: true,
      type: Object
    },
    scheduleFinished: {
      default: false,
      type: Boolean
    }
  },
  computed: {
    canArchiveContract () {
      return this.scheduleFinished && this.schedule.is_archive === 0;
    },
    isVindication () {
      return this.schedule.contract_end_date_has_passed;
    },
    terminationNoticeButtonText () {
      return this.isVindication ? 'Wyślij wezwanie spłaty umowy' : 'Wyślij wypowiedzenie umowy';
    },
    terminateButtonText () {
      return this.isVindication ? 'Windykuj skończoną umowę' : 'Wypowiedz umowę';
    },
    terminationSentText () {
      return this.isVindication ? 'Wysłano wezwanie do spłaty' : 'Wysłano wypowiedzenie';
    },
  },
  data () {
    return {
      actionInProgress: false,
      caseIsExplainedDate: null,
      terminatedDate: null,
      terminationSendDate: null
    }
  },
  mounted () {
  },
  methods: {
    archiveContract () {
      Vue.swal({
        title: 'Uwaga',
        html: 'Czy potwierdzasz archiwizację umowy?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Tak',
        cancelButtonText: 'Nie',
        buttonsStyling: true
      }).then((response) => {
        if(response.value) {
          this.submitArchive();
        }
      }).catch((errors) =>{
        console.log(errors);
      })
    },
    submitArchive () {
      if (!this.allGuaranteesHaveAgreement) {
        Vue.swal({
          type: 'warning',
          title: 'Wystąpił błąd',
          text:'Nie wysłano zgody na zdjęcie wszystkich zabezpieczeń',
          showConfirmButton: true,
        });
      }
      else if (this.isAdmin !== 1 && (!this.schedule.provision_invoice_id || (!this.schedule.interest_invoice_id && this.schedule.invoice_interests_amount !== 0 ))) {
        Vue.swal({
          type: 'warning',
          title: 'Wystąpił błąd',
          text:'Przed zarchiwizowaniem umowy należy wygenerować niezbędne faktury',
          showConfirmButton: true,
        });
      }
      else {
        axios.post('api/schedules/add-contract-to-archive', {id: this.schedule.id}).then(response => {
          Vue.swal({
            type: 'success',
            title: 'Umowa została poprawnie zarchiwizowana.',
            showConfirmButton: true,
          }).then(() => {
            this.$bus.$emit('reload-contract');
          });
        }).catch((error) =>{
          Vue.swal({
            type: 'warning',
            title: 'Wystąpił błąd',
            text: error.response.data.error ? error.response.data.error : 'Spróbuj ponownie później',
            showConfirmButton: true,
          });
        })
      }
    },
    sendTerminationNotice () {
      setTimeout(() => {
        axios.post('api/schedules/terminate-loan-contract', {
          id: this.schedule.id,
          terminated_send_date: this.terminationSendDate
        }).then(response => {
          const successMessage = this.isVindication 
            ? 'Wysłano wezwanie do spłaty umowy' 
            : 'Wysłano wypowiedzenie umowy';
          Vue.swal({
            type: 'success',
            title: successMessage,
            showConfirmButton: true,
          }).then(() => {
            this.$bus.$emit('reload-contract');
          });
        }).catch((errors) =>{
          console.log(errors);
        })
      })
    },
    terminateSchedule () {
      setTimeout(() => {
        axios.post('api/schedules/terminate-loan-contract', {
          id: this.schedule.id,
          terminated_date: this.terminatedDate
        }).then(response => {
          const successMessage = this.isVindication 
            ? 'Rozpoczęto windykację skończonej umowy' 
            : 'Umowa została wypowiedziana';
          Vue.swal({
            type: 'success',
            title: successMessage,
            showConfirmButton: true,
          }).then(() => {
            this.$bus.$emit('reload-contract');
          });
        }).catch((errors) =>{
          console.log(errors);
        })
      })
    },
    scheduleInExecution () {
      setTimeout(() => {
        axios.post('api/schedules/set-schedule-as-cased', {
          id: this.schedule.id,
          case_is_explained_date: this.caseIsExplainedDate
        }).then(response => {
          Vue.swal({
            type: 'success',
            title: 'Data rozpoczęcia egzekucji została ustawiona',
            showConfirmButton: true,
          }).then(() => {
            this.$bus.$emit('reload-contract');
          });
        }).catch((errors) =>{
          console.log(errors);
        })
      })
    },
    sendReminder () {
      this.actionInProgress = true;

      Vue.swal({
        title: 'Uwaga',
        html: 'Czy na pewno chcesz wysłać podsumowanie zaległości do&nbsp;klienta?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Wyślij na domyślne dane klienta',
        cancelButtonText: 'Wyślij na wybrane dane',
        buttonsStyling: true
      }).then(response => {
        if (response.value) {
          axios.post('api/notifications/send-amount-debt-to-client', {
            id: this.schedule.id
          }).then(response => {
            this.actionInProgress = false;

            Vue.swal({
              type: 'success',
              title: 'Podsumowanie zostało wysłane na adres e-mail klienta.',
              showConfirmButton: true,
            });
          }).catch((error) => {
            this.actionInProgress = false;
            Vue.swal({
              type: 'warning',
              title: 'Wystąpił błąd',
              text: error.response.data.error ? error.response.data.error : 'Spróbuj ponownie później',
              showConfirmButton: true,
            });
          })
        }
        else if(response.dismiss === 'cancel'){
          Vue.swal({
            title: 'Uzupełnij dane do wysyłki przypomnienia',
            html:
              '<div class="form-group text-left">' +
              '<label>Adres e-mail</label>' +
              '<input type="text" class="form-control" id="swal-input1" >' +
              '</div>' +
              '<div class="form-group text-left">' +
              '<label>Telefon</label>' +
              '<input type="text" class="form-control" id="swal-input2">' +
              '</div>',
            focusConfirm: false,
            preConfirm: () => {
              let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
              let email_true =  re.test(String(document.getElementById('swal-input1').value).toLowerCase());
              if (document.getElementById('swal-input1').value.length <= 0 || document.getElementById('swal-input2').value < 9 || !email_true) {
                Vue.swal.showValidationMessage(`Nieprawidłowe dane w formularzu`);
                return false;
              }
              return [
                document.getElementById('swal-input1').value,
                document.getElementById('swal-input2').value
              ]
            },
            type: 'info',
            showCancelButton: true,
            confirmButtonText: 'Wyślij',
            cancelButtonText: 'Anuluj',
            buttonsStyling: true,
          }).then(response => {
            if (response.value) {
              axios.post('api/notifications/send-amount-debt-to-client', {
                id: this.schedule.id,
                mail_to: response.value[0],
                phone_to: response.value[1]
              }).then(response => {
                this.actionInProgress = false;

                Vue.swal({
                  type: 'success',
                  title: 'Podsumowanie zostało wysłane na podane dane.',
                  showConfirmButton: true,
                });
              }).catch((error) => {
                this.actionInProgress = false;
                Vue.swal({
                  type: 'warning',
                  title: 'Wystąpił błąd',
                  text: error.response.data.error ? error.response.data.error : 'Spróbuj ponownie później',
                  showConfirmButton: true,
                });
              })
            }
            else if (response.dismiss) {
              this.actionInProgress = false;
            }
          });
        }
        else {
          this.actionInProgress = false;
        }
      });
    },
  }
}
</script>